import { format } from "date-fns";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useQuery } from "urql";

import { Button } from "@/components/ui/button";
import { graphql } from "@/gen";

const allTournamentSeriesQuery = graphql(`
    query AllTournamentSeries {
        allTournamentSeries {
            id
            title
            startAt
        }
    }
`);

export default function TournamentSeriesRoute() {
    const [result] = useQuery({
        query: allTournamentSeriesQuery,
    });

    if (result.fetching) return <p>Loading tournament series...</p>;
    if (result.error) return <p>Error: {result.error.message}</p>;

    const seriesList = result.data?.allTournamentSeries || [];

    return (
        <div className="m-4 flex flex-col gap-4">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-bold">Tournament Series</h1>
                <Button asChild>
                    <Link to="/tournament-series/new">New tournament series</Link>
                </Button>
            </div>
            {seriesList.length === 0 ? (
                <p>No tournament series found.</p>
            ) : (
                <ul className="divide-y divide-gray-200">
                    {seriesList.map(series => (
                        <li key={series.id} className="py-3">
                            <Link
                                to={`/tournament-series/${series.id}`}
                                className="flex items-center justify-between rounded p-3 transition-colors hover:bg-gray-100"
                            >
                                <div>
                                    <p className="text-lg font-medium">{series.title}</p>
                                    <p className="text-muted-foreground text-sm">
                                        {format(new Date(series.startAt), "dd.MM.yyyy")}
                                    </p>
                                </div>
                                <ArrowRight size={20} />
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
